(function () {
  function hideEmptyFilterGroups() {
    $('.x-collection-v2 .js--collection-filter-item').each(function () {
      var $item = $(this);
      var hasVisible = $item.find('.x-collection__filter-content-item').filter(function () {
        return $(this).css('display') !== 'none';
      }).length;
      $item.toggle(!!hasVisible);
    });
  }

  function pruneUnusedLineFilters() {
    var $shelves = $('.x-collection-v2 .js--collection-product-items .js--shelf');
    $('.x-collection-v2 .js--collection-filter-field[data-cv2-match]').each(function () {
      var $field = $(this);
      var needle = String($field.attr('data-cv2-match') || '')
        .trim()
        .toLowerCase();
      var used = $field.hasClass('is--active');

      if (!used && needle && $shelves.length) {
        $shelves.each(function () {
          var hay = String($(this).attr('data-cv2-haystack') || '').toLowerCase();
          if (hay.indexOf(needle) !== -1) {
            used = true;
            return false;
          }
        });
      }

      $field.closest('.x-collection__filter-content-item').toggle(used);
    });

    hideEmptyFilterGroups();
  }

  function syncSortActiveState(forcedSort) {
    // Prefer forced value / Shopify.queryParams — URL is only updated after AJAX pushState.
    var sort =
      forcedSort ||
      (window.Shopify && Shopify.queryParams && Shopify.queryParams.sort_by) ||
      new URLSearchParams(window.location.search).get('sort_by') ||
      'manual';

    $('.x-collection-v2 .js--collection-sort-by-item').removeClass('is--active');
    var $active = $('.x-collection-v2 .js--collection-sort-by-item[data-select="' + sort + '"]').addClass(
      'is--active'
    );

    var label = ($active.first().text() || '').trim();
    if (!label) {
      label = sort === 'price-ascending' ? 'Menor Preço' : sort === 'price-descending' ? 'Maior Preço' : 'Lançamentos';
    }
    $('.x-collection-v2 .js--cv2-sort-label').text(label);
  }

  function bindShelfAddToCart() {
    var buyState = {
      $form: null,
      $btn: null,
      buyType: 'unique'
    };

    function prepareQty($form) {
      var $qty = $form.find('.js--qty-selector');

      // addProductCart reads #quantity inside the form — ensure a stable id
      $('.x-collection-v2 .js--qty-selector').each(function () {
        var $input = $(this);
        if ($input.attr('id') === 'quantity') {
          $input.attr('id', $input.data('cv2-qty-id') || ('quantity-' + Math.random().toString(36).slice(2)));
        }
      });

      if (!$qty.data('cv2-qty-id')) {
        $qty.data('cv2-qty-id', $qty.attr('id'));
      }
      $qty.attr('id', 'quantity');

      if (window.Cvs) {
        window.Cvs.productQty = parseInt($qty.val(), 10) || 1;
      }

      return $qty;
    }

    function setVariant($form, variantId) {
      $form.attr('data-variant-id', variantId);
      $form.find('select[name="id"]').val(String(variantId));
    }

    function addToCart($form, $btn, variantId, isMonthly) {
      prepareQty($form);
      setVariant($form, variantId);

      function doAdd() {
        if (typeof addProductCart === 'function') {
          addProductCart({ target: $btn.get(0) });
        }
        closeBuyModal();
      }

      if (isMonthly && typeof Swal !== 'undefined' && Swal.fire) {
        Swal.fire({
          title:
            'ATENÇÂO!, Você selecionou a compra mensal, isso significa que você será cobrado todo mês de forma recorrente.',
          icon: 'warning',
          confirmButtonColor: '#22bb33',
          confirmButtonText: 'Estou ciente!',
          cancelButtonText: 'Não, obrigado',
          showCancelButton: true
        }).then(function (result) {
          if (result.isConfirmed) {
            doAdd();
          }
        });
        return;
      }

      doAdd();
    }

    function openBuyModal($form, $btn) {
      var $modal = $('.js--cv2-buy-modal');
      if (!$modal.length) return;

      // Keep modal above theme overlays / stacking contexts
      if ($modal.parent()[0] !== document.body) {
        $modal.appendTo(document.body);
      }

      buyState.$form = $form;
      buyState.$btn = $btn;
      buyState.buyType = 'unique';

      var title = $form.attr('data-cv2-title') || '';
      var image = $form.attr('data-cv2-image') || '';
      var uniquePrice = $form.attr('data-cv2-unique-price') || '';
      var monthlyPrice = $form.attr('data-cv2-monthly-price') || '';
      var discount = parseInt($form.attr('data-cv2-discount'), 10) || 0;

      $modal.find('.js--cv2-buy-title').text(title);
      $modal.find('.js--cv2-buy-img').attr({ src: image, alt: title });
      $modal.find('.js--cv2-buy-unique-price').text(uniquePrice);
      $modal.find('.js--cv2-buy-unique-price-strike').text(uniquePrice);
      $modal.find('.js--cv2-buy-monthly-price').text(monthlyPrice);

      var $badge = $modal.find('.js--cv2-buy-discount');
      if (discount > 0) {
        $badge.text(discount + '% OFF').prop('hidden', false);
      } else {
        $badge.prop('hidden', true).text('');
      }

      $modal.find('.js--cv2-buy-opt').removeClass('is--active');
      $modal.find('.js--cv2-buy-opt[data-buy-type="unique"]').addClass('is--active');
      $modal.find('.js--cv2-buy-confirm').text('Adicionar ao carrinho');

      $modal.prop('hidden', false).attr('aria-hidden', 'false').addClass('is--open');
      $('body').addClass('is--cv2-buy-modal-open');
    }

    function closeBuyModal() {
      var $modal = $('.js--cv2-buy-modal');
      $modal.prop('hidden', true).attr('aria-hidden', 'true').removeClass('is--open');
      $('body').removeClass('is--cv2-buy-modal-open');
      buyState.$form = null;
      buyState.$btn = null;
      buyState.buyType = 'unique';
    }

    $(document)
      .off('click.cv2Buy', '.x-shelf-v2 .customBtnAdd')
      .on('click.cv2Buy', '.x-shelf-v2 .customBtnAdd', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $btn = $(this);
        var $form = $btn.closest('form');
        var monthlyId = $form.attr('data-cv2-monthly-id');
        var uniqueId = $form.attr('data-cv2-unique-id') || $form.attr('data-variant-id');

        if (monthlyId && String(monthlyId) !== String(uniqueId)) {
          openBuyModal($form, $btn);
          return;
        }

        addToCart($form, $btn, uniqueId, false);
      });

    $(document)
      .off('click.cv2BuyModal')
      .on('click.cv2BuyModal', '.js--cv2-buy-opt', function () {
        var $opt = $(this);
        var $modal = $opt.closest('.js--cv2-buy-modal');
        buyState.buyType = $opt.attr('data-buy-type') || 'unique';
        $modal.find('.js--cv2-buy-opt').removeClass('is--active');
        $opt.addClass('is--active');
        $modal
          .find('.js--cv2-buy-confirm')
          .text(buyState.buyType === 'monthly' ? 'Assinar e adicionar' : 'Adicionar ao carrinho');
      })
      .on('click.cv2BuyModal', '.js--cv2-buy-confirm', function () {
        if (!buyState.$form || !buyState.$btn) return;

        var isMonthly = buyState.buyType === 'monthly';
        var variantId = isMonthly
          ? buyState.$form.attr('data-cv2-monthly-id')
          : buyState.$form.attr('data-cv2-unique-id') || buyState.$form.attr('data-variant-id');

        if (!variantId) return;
        addToCart(buyState.$form, buyState.$btn, variantId, isMonthly);
      })
      .on('click.cv2BuyModal', '.js--cv2-buy-close, .js--cv2-buy-backdrop', function () {
        closeBuyModal();
      });

    $(document)
      .off('keydown.cv2BuyModal')
      .on('keydown.cv2BuyModal', function (e) {
        if (e.key === 'Escape' && $('.js--cv2-buy-modal').hasClass('is--open')) {
          closeBuyModal();
        }
      });
  }

  function openFiltersByDefault() {
    $('.x-collection-v2 .js--collection-filter-item').each(function () {
      var $item = $(this);
      var title = $item.find('.x-collection__filter-title').text().trim().toLowerCase();
      var isPrice = title.indexOf('preço') !== -1 || title.indexOf('preco') !== -1;
      $item.toggleClass('is--collapsed', !isPrice);
      $item.find('.js--collection-filter-title').toggleClass('is--active', isPrice);
    });
  }

  function bindFilterAccordions() {
    document.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest(
          '.x-collection-v2 .js--collection-filter-open, .x-collection-v2 .x-collection__filter-title-container'
        );
        if (!trigger) return;
        if (trigger.closest('.x-collection-v2__sort-bar')) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var $item = $(trigger).closest('.js--collection-filter-item');
        if (!$item.length) return;

        var willCollapse = !$item.hasClass('is--collapsed');
        $item.toggleClass('is--collapsed', willCollapse);
        $item.find('.js--collection-filter-title').toggleClass('is--active', !willCollapse);
      },
      true
    );
  }

  // Legacy enext scrolls to .js--collection-product-items after every filter/sort AJAX.
  // On v2 that jump feels like the page "falls" — keep the current scroll position.
  function preventLegacyFilterScrollJump() {
    if ($.fn.animate.__cv2Patched) return;

    var originalAnimate = $.fn.animate;
    $.fn.animate = function (props) {
      if (
        $('.x-collection-v2').length &&
        props &&
        typeof props === 'object' &&
        Object.prototype.hasOwnProperty.call(props, 'scrollTop') &&
        this.filter('html, body').length
      ) {
        return this.stop(true, false);
      }
      return originalAnimate.apply(this, arguments);
    };
    $.fn.animate.__cv2Patched = true;
  }

  function preventHashLinkJumps() {
    $(document).on(
      'click.cv2Hash',
      '.x-collection-v2 a[href="#"], .x-collection-v2 a[href=""]',
      function (e) {
        e.preventDefault();
      }
    );
  }

  function updateVisibleProductCount() {
    var visible = $('.x-collection-v2 .js--collection-product-items .js--shelf:visible').length;
    var $count = $('.x-collection-v2__toolbar-count');
    if (!$count.length) return;
    $count.text(visible + (visible === 1 ? ' produto' : ' produtos'));
  }

  function syncFilterChips() {
    var $chips = $('.x-collection-v2 .js--cv2-chips');
    if (!$chips.length) return;

    var labels = [];
    $('.x-collection-v2 .js--collection-filter-field.is--active').each(function () {
      var label = $(this).find('.x-collection__filter-name').text().trim();
      if (label && labels.indexOf(label) === -1) labels.push(label);
    });

    if (!labels.length) {
      $chips.empty().attr('hidden', true);
      return;
    }

    var html = labels
      .map(function (label) {
        return '<span class="x-collection-v2__chip">' + label + '</span>';
      })
      .join('');
    html +=
      '<a href="#" class="x-collection-v2__chip-clear js--collection-filter-clear-all">Limpar</a>';
    $chips.html(html).removeAttr('hidden');
  }

  function syncActiveFiltersFromConstraint() {
    var constraint =
      (window.Shopify && Shopify.queryParams && Shopify.queryParams.constraint) ||
      new URLSearchParams(window.location.search).get('constraint') ||
      '';
    if (!constraint) {
      syncFilterChips();
      return;
    }

    var handles = constraint.split('+').filter(Boolean);
    $('.x-collection-v2 .js--collection-filter-field[data-handle]').each(function () {
      var $field = $(this);
      if ($field.is('[data-cv2-match], [data-cv2-qty-filter], [data-cv2-peso-filter]')) return;
      var handle = String($field.attr('data-handle') || '');
      if (handles.indexOf(handle) !== -1) {
        $field.addClass('is--active');
        $field.find('input').prop('checked', true);
      }
    });

    syncFilterChips();
  }

  function getShelfQty($shelf) {
    var hay = String($shelf.attr('data-cv2-haystack') || '');
    var match = hay.match(/qty:\s*(\d+)/i);
    return match ? parseInt(match[1], 10) : NaN;
  }

  function getShelfWeight($shelf) {
    var raw = $shelf.attr('data-cv2-weight');
    if (raw !== undefined && raw !== null && String(raw).trim() !== '') {
      var fromAttr = parseFloat(String(raw).replace(',', '.').replace(/[^\d.]/g, ''));
      if (!isNaN(fromAttr)) return fromAttr;
    }

    var hay = String($shelf.attr('data-cv2-haystack') || '');
    var match =
      hay.match(/peso:\s*([\d.,]+)/i) ||
      hay.match(/itens\s*:\s*([\d.,]+)\s*kg/i) ||
      hay.match(/([\d.,]+)\s*kg/i);
    return match ? parseFloat(String(match[1]).replace(',', '.')) : NaN;
  }

  function applyClientFilters() {
    var needles = [];
    $('.x-collection-v2 .js--collection-filter-field.is--active[data-cv2-match]').each(function () {
      var needle = String($(this).attr('data-cv2-match') || '')
        .trim()
        .toLowerCase();
      if (needle) needles.push(needle);
    });

    var qtyRanges = [];
    $('.x-collection-v2 .js--collection-filter-field.is--active[data-cv2-qty-filter]').each(function () {
      var minRaw = $(this).attr('data-cv2-qty-min');
      var maxRaw = $(this).attr('data-cv2-qty-max');
      var min = minRaw !== undefined && minRaw !== '' ? parseInt(minRaw, 10) : 0;
      var max = maxRaw !== undefined && maxRaw !== '' ? parseInt(maxRaw, 10) : Number.POSITIVE_INFINITY;
      if (!isNaN(min) && !isNaN(max)) {
        qtyRanges.push({ min: min, max: max });
      }
    });

    var pesoRanges = [];
    $('.x-collection-v2 .js--collection-filter-field.is--active[data-cv2-peso-filter]').each(function () {
      var minRaw = $(this).attr('data-cv2-peso-min');
      var maxRaw = $(this).attr('data-cv2-peso-max');
      var min = minRaw !== undefined && minRaw !== '' ? parseFloat(String(minRaw).replace(',', '.')) : 0;
      var max =
        maxRaw !== undefined && maxRaw !== ''
          ? parseFloat(String(maxRaw).replace(',', '.'))
          : Number.POSITIVE_INFINITY;
      if (!isNaN(min) && !isNaN(max)) {
        pesoRanges.push({ min: min, max: max });
      }
    });

    var $shelves = $('.x-collection-v2 .js--collection-product-items .js--shelf');
    if (!needles.length && !qtyRanges.length && !pesoRanges.length) {
      $shelves.show();
      updateVisibleProductCount();
      return;
    }

    $shelves.each(function () {
      var $shelf = $(this);
      var hay = String($shelf.attr('data-cv2-haystack') || '').toLowerCase();
      var ok = true;

      if (needles.length) {
        ok = false;
        for (var i = 0; i < needles.length; i++) {
          if (hay.indexOf(needles[i]) !== -1) {
            ok = true;
            break;
          }
        }
      }

      if (ok && qtyRanges.length) {
        var qty = getShelfQty($shelf);
        ok = false;
        if (!isNaN(qty)) {
          for (var j = 0; j < qtyRanges.length; j++) {
            if (qty >= qtyRanges[j].min && qty <= qtyRanges[j].max) {
              ok = true;
              break;
            }
          }
        }
      }

      if (ok && pesoRanges.length) {
        var weight = getShelfWeight($shelf);
        ok = false;
        if (!isNaN(weight)) {
          for (var k = 0; k < pesoRanges.length; k++) {
            if (weight >= pesoRanges[k].min && weight <= pesoRanges[k].max) {
              ok = true;
              break;
            }
          }
        }
      }

      $shelf.toggle(ok);
    });

    updateVisibleProductCount();
  }

  function bindClientFilters() {
    // Line / quantidade / peso: multi-select with OR logic (client-side).
    document.addEventListener(
      'click',
      function (event) {
        var field = event.target.closest(
          '.x-collection-v2 .js--collection-filter-field[data-cv2-match], .x-collection-v2 .js--collection-filter-field[data-cv2-qty-filter], .x-collection-v2 .js--collection-filter-field[data-cv2-peso-filter]'
        );
        if (!field || field.classList.contains('is--disable')) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        $(field).toggleClass('is--active');
        applyClientFilters();
        syncFilterChips();
      },
      true
    );

    $(document).on(
      'click.cv2ClientClear',
      '.x-collection-v2 .js--collection-filter-clear-all, .x-collection-v2 .js--collection-filter-clear',
      function () {
        $(
          '.x-collection-v2 .js--collection-filter-field[data-cv2-match], .x-collection-v2 .js--collection-filter-field[data-cv2-qty-filter], .x-collection-v2 .js--collection-filter-field[data-cv2-peso-filter]'
        ).removeClass('is--active');
        window.setTimeout(function () {
          applyClientFilters();
          syncFilterChips();
        }, 50);
      }
    );
  }

  function bindMobileDrawers() {
    function closeDrawers() {
      $('.x-collection-v2 .js--collection-filter-container-mobile').removeClass('is--active');
      $('.x-collection-v2 .js--sort-by-item-container-mobile').removeClass('is--active');
      if (window.Cvs && Cvs.overlayMobile) {
        Cvs.overlayMobile.removeClass('is--active');
      }
      $('body').removeClass('has--no-scroll');
    }

    $(document).on(
      'click.cv2DrawerClose',
      '.x-collection-v2 .js--collection-filter-close',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawers();
      }
    );

    $(document).on('click.cv2DrawerOverlay', function (e) {
      if (!window.Cvs || !Cvs.overlayMobile || !Cvs.overlayMobile.length) return;
      if (!Cvs.overlayMobile.hasClass('is--active')) return;
      if (e.target !== Cvs.overlayMobile[0]) return;
      closeDrawers();
    });
  }

  function whenPageLoaderGone(callback) {
    var body = document.body;
    var loader = document.querySelector('.ajax-loader__container');
    var done = false;

    function finish() {
      if (done) return;
      done = true;
      callback();
    }

    function loaderStillVisible() {
      if (body.classList.contains('has--loader')) return true;
      if (!loader) return false;
      var style = window.getComputedStyle(loader);
      return style.visibility !== 'hidden' && parseFloat(style.opacity) > 0.08;
    }

    if (!loaderStillVisible()) {
      finish();
      return;
    }

    var observer = new MutationObserver(function () {
      if (!body.classList.contains('has--loader')) {
        observer.disconnect();
        // Loader fade is 0.5s — wait it out before revealing animations
        window.setTimeout(finish, 550);
      }
    });
    observer.observe(body, { attributes: true, attributeFilter: ['class'] });

    if (loader) {
      loader.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName && e.propertyName !== 'opacity' && e.propertyName !== 'visibility') return;
        loader.removeEventListener('transitionend', onEnd);
        finish();
      });
    }

    // Already fading (class removed before we attached): just wait the fade
    if (!body.classList.contains('has--loader')) {
      window.setTimeout(finish, 550);
    }

    // Failsafe: never block forever
    window.setTimeout(function () {
      observer.disconnect();
      finish();
    }, 4500);
  }

  function startEntranceAnimations() {
    var $root = $('.x-collection-v2');
    if (!$root.length) return;

    function play() {
      $root.removeClass('js--cv2-anim-pending').addClass('is--cv2-anim');
    }

    whenPageLoaderGone(function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(play);
      });
    });

    // Failsafe: never leave content stuck invisible
    window.setTimeout(function () {
      if ($root.hasClass('js--cv2-anim-pending')) play();
    }, 5000);
  }

  function replayProductEntrance() {
    var $root = $('.x-collection-v2');
    if (!$root.hasClass('is--cv2-anim')) return;

    var $items = $root.find('.x-shelf-v2');
    $items.each(function (i) {
      var el = this;
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = '';
      el.style.animationDelay = Math.min(i, 12) * 0.1 + 0.15 + 's';
    });
  }

  $(document).ready(function () {
    if (!$('.x-collection-v2').length) return;

    // Price ranges stay single-select within the group: constraint tags use AND,
    // so two price bands together would return zero products.
    // Cestas Básicas + quantidade keep multi-select (OR) via client filters.
    if (window.Cvs) {
      Cvs.enableFilterMultipleChoice = false;
    }

    pruneUnusedLineFilters();
    openFiltersByDefault();
    bindFilterAccordions();
    syncSortActiveState();
    bindShelfAddToCart();
    preventLegacyFilterScrollJump();
    preventHashLinkJumps();
    bindClientFilters();
    bindMobileDrawers();
    syncActiveFiltersFromConstraint();
    startEntranceAnimations();

    // Ver composição: re-query zoom container (legacy caches selector once at boot)
    $(document)
      .off('click.cv2Compose', '.x-shelf-v2 .js--shelf-show-more')
      .on('click.cv2Compose', '.x-shelf-v2 .js--shelf-show-more', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var productName = $(this).data('product');
        var $zoom = $('.x-collection-v2 .js--geral-collection-zoom');
        if (!$zoom.length) return;

        $zoom.addClass('is--active');
        if (window.innerWidth < 768) {
          $('body').addClass('has--no-scroll');
        }

        $zoom.find('.x-shelf__special-container').each(function () {
          var $panel = $(this);
          $panel.toggleClass('is--active', $panel.data('target') === productName);
        });
      });

    $(document)
      .off('click.cv2ComposeClose', '.x-collection-v2 .js--product-close')
      .on('click.cv2ComposeClose', '.x-collection-v2 .js--product-close', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $(this).closest('.x-shelf__special-container').removeClass('is--active');
        $('body').removeClass('has--no-scroll');
        $('.x-collection-v2 .js--geral-collection-zoom').removeClass('is--active');
      });

    $(document).on('click.cv2Sort', '.x-collection-v2 .js--collection-sort-by-item', function () {
      syncSortActiveState($(this).attr('data-select'));
    });

    $(document).on(
      'click.cv2Sync',
      '.x-collection-v2 .js--collection-filter-field:not([data-cv2-match]):not([data-cv2-qty-filter]):not([data-cv2-peso-filter]), .x-collection-v2 .js--collection-filter-clear-all',
      function () {
        window.setTimeout(function () {
          syncSortActiveState();
          syncFilterChips();
        }, 350);
      }
    );

    $(document).ajaxComplete(function (_event, _xhr, settings) {
      if (!$('.x-collection-v2').length) return;
      if (settings && settings.url && /\/collections\//.test(settings.url)) {
        syncSortActiveState();
        window.setTimeout(function () {
          pruneUnusedLineFilters();
          applyClientFilters();
          syncFilterChips();
          replayProductEntrance();
        }, 30);
      }
    });
  });
})();
